import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import Analytics from './helpers/Analytics';
import { loadPayeezyScript } from './helpers/LoadPayeezyScript';
import Store from './redux/store/Store';
import reportWebVitals from './reportWebVitals';
import { theme, } from './styles/muiTheme';
import './index.scss';

loadPayeezyScript();

Analytics.init();

const AppBuilder = () => {
  return (
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  );
}

render(
  <React.StrictMode>
    <Provider store={Store}>
      <AppBuilder />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
